
/* JWT */
import { decodeToken } from "react-jwt"

/* Constants */
import { env } from "../constants"


/* Fields */
export const currencies = [
    {
        name: "Доллар",
        code: "USD",
        isAfter: 0,
        symbol: "$"
    },
    {
        name: "Евро",
        code: "EUR",
        isAfter: 0,
        symbol: "€"
    },
    {
        name: "Тенге",
        code: "KZT",
        isAfter: 1,
        symbol: "₸"
    },
    {
        name: "Рубль",
        code: "RUB",
        isAfter: 1,
        symbol: "₽"
    },
    {
        name: "Kyrgyz som",
        code: "KGS",
        isAfter: 1,
        symbol: "с."
    },
    {
        name: "Uzbek sum",
        code: "UZS",
        isAfter: 1,
        symbol: "сўм"
    },
    {
        name: "Украинская гривна",
        code: "UAH",
        isAfter: 1,
        symbol: "₴"
    },
    {
        name: "Индийская рупия",
        code: "INR",
        isAfter: 1,
        symbol: "₹"
    },
    {
        name: "Армянский драм",
        code: "AMD",
        isAfter: 1,
        symbol: "֏"
    },
    {
        name: "Канадский доллар",
        code: "CAD",
        isAfter: 1,
        symbol: "CA$"
    },
    {
        name: "Польский злотый",
        code: "PLN",
        isAfter: 1,
        symbol: "zł"
    },
    {
        name: "Египетский фунт",
        code: "EGP",
        isAfter: 1,
        symbol: "ج.م"
    },
    {
        name: "Датская крона",
        code: "DKK",
        isAfter: 1,
        symbol: "kr"
    },
    {
        name: "Румынский лей",
        code: "RON",
        isAfter: 1,
        symbol: "L"
    },
    {
        name: "Молдавский лей",
        code: "MDL",
        isAfter: 1,
        symbol: "L"
    },
    {
        name: "Болгарский Лев",
        code: "BGN",
        isAfter: 1,
        symbol: "лв"
    },
    {
        name: "Шведская крона",
        code: "SEK",
        isAfter: 1,
        symbol: "kr"
    },
    {
        name: "Норвежская крона",
        code: "NOK",
        isAfter: 1,
        symbol: "kr"
    },
    {
        name: "Турецкая лира",
        code: "TRY",
        isAfter: 1,
        symbol: "₺"
    },
    {
        name: "Китайский юань",
        code: "CNY",
        isAfter: 1,
        symbol: "¥"
    },
    {
        name: "Пакистанская рупия",
        code: "PKR",
        isAfter: 1,
        symbol: "Rs"
    },
    {
        name: "Туркменский манат",
        code: "TMT",
        isAfter: 1,
        symbol: "T"
    },
    {
        name: "Таджикский сомони",
        code: "TJS",
        isAfter: 1,
        symbol: "SM"
    },
    {
        name: "Азербайджанский манат",
        code: "AZN",
        isAfter: 1,
        symbol: "₼"
    },
    {
        name: "Грузинский лари",
        code: "GEL",
        isAfter: 1,
        symbol: "₾"
    }
]


/* Counter */
export const counter = (value, fixed = 1) => {

    let count = value

    if (parseInt(value) >= 1000) {
        if (parseInt(value) % 1000 === 0) {
            const calculate = Math.round(parseInt(value) / 1000)
            count = `${calculate}K`
        }
        else if (parseInt(value) % 100 === 0) {
            const calculate = (parseInt(value) / 1000).toFixed(fixed)
            count = `${calculate}K`
        }
    }

    if (parseInt(value) >= 1000000) {
        const calculate = (parseInt(value) / 1000000).toFixed(fixed)
        count = `${calculate}M`
    }

    return count
}

/* Side-bet max limits as a fraction of the main max (matches the paytable):
   Perfect Pairs = max/10, 21+3 = max/20, Bust Bonus = max/50, Crazy 7 = max/200 */
export const SIDE_DIVISOR = { perfectPair: 10, twentyone: 20, bustBonus: 50, crazySeven: 200 }

/* Max stake allowed for a given bet key */
export const betMax = (key, max) => key === "main"
    ? parseFloat(max)
    : parseFloat(max) / (SIDE_DIVISOR[key] || 10)

/* Balance convertor */
export const convertor = (number, currency, symbol = " ") => {

    let space = '\xa0'
    /* Check the price for the void */
    if (number === null || number === undefined)
        return ""

    const balance = parseFloat(number)

    let final = Number.isInteger(balance) ? balance.toFixed(0) : balance.toFixed(2)

    if (currency.toLowerCase() === 'uzs') {
        final = counter(final)
    }

    const index = currencies.findIndex(c => c.code.toLowerCase() === currency.toLowerCase())

    let beforeSymbol = ''
    let afterSymbol = ''

    if (index > -1) {
        if (currencies[index].isAfter === 1) {
            afterSymbol = space + currencies[index].symbol
        }
        if (currencies[index].isAfter === 0) {
            beforeSymbol = currencies[index].symbol + space
        }
    }
    else {
        beforeSymbol = "$" + space
    }

    /* Return price with spaces and currency */
    return beforeSymbol + final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, symbol) + afterSymbol
}


/* Get Token Values */
export const getData = token => {

    /* Default VALUES */
    const _max = 5000
    const _min = 50
    const _chips = []
    const _currency = "USD"
    const _identifier = "1"
    const _backColor = ""
    const _gameImg = null

    const DEFAULT_VALUES = {
        max: _max,
        min: _min,
        chips: _chips,
        currency: _currency,
        identifier: _identifier,
        backColor: _backColor,
        gameImg: _gameImg
    }

    /* Get Image */
    const getImage = value => value ? `${env.mediapoint}/images/table-images/${value}` : null

    /* Check Token */
    if (!token) {
        return DEFAULT_VALUES
    }

    /* Decode Token */
    const data = decodeToken(token)

    /* Check Data */
    if (!data) {
        return DEFAULT_VALUES
    }

    return {
        max: check(data.max, _max),
        min: check(data.min, _min),
        chips: getChips(data.chips),
        currency: check(data.currency, _currency),
        identifier: check(data.identifier, _identifier),
        backColor: check(data.backColor, _backColor),
        gameImg: getImage(data.gameImg)
    }

}

/* Check Value */
export const check = (value, defaultValue) => {

    if (value !== null && value !== undefined) {
        return value
    }

    return defaultValue
}

/* Get Chips */
const getChips = data => {

    let chips = []

    if (data && Array.isArray(data) && data.length === 6) {
        data.forEach(item => {
            if (item) {
                const list = item.split("-")
                if (list && Array.isArray(list) && list.length > 1) {
                    chips.push({ value: parseInt(list[0]), color: list[1] })
                }
            }
        })
    }

    return chips
}



/* Get Total */
export const getTotal = (stake = {}) => {

    /* Check Stake */
    if (stake === null || stake === undefined) {
        return 0
    }

    return Object.values(stake).reduce((sum, value) => {
        return sum + parseFloat(value)
    }, 0)

}

/* Get Reconnection Chips List */
export const reconnectionChipsList = (stake = {}, refresh = false) => {

    /* Check  */
    if (stake === null || stake === undefined) {
        return []
    }

    let list = []

    for (const [key, value] of Object.entries(stake)) {
        if (value > 0) {
            list.push({ value, type: "add", target: key, refresh })
        }
    }

    return list
}


/* Sorted & Unique Cards */
export const getUniqueCards = (cards = []) => {

    /* Check Array */
    if (cards && Array.isArray(cards) && cards.length > 0) {
        return Array.from(new Map(cards.map(card => [card.uid, card])).values()).sort((a, b) => a.now - b.now)
    }

    return []
}

